import dayjs from "dayjs";

export function useDate() {
    const dateFormat = function (value) {
        const date = dayjs(value);
        return date.format("DD/MM/YYYY");
    }

    const dateTimeFormat = function(value) {
        const date = dayjs(value);
        return date.format('DD/MM/YYYY HH:mm');

    }

    return {
        dateFormat,
        dateTimeFormat
    }
}